import React, { useState } from 'react';
import LabelField from '../labelField/LabelField';
import { Button } from 'app/components';
import DateTimeModal from './dateTimeModal';
import VenueModal from './venueModal';
import MeetingDetailsModal from './meetingDetailsModal'
import './style';
import { differenceInHours } from 'date-fns';

const Locale = (props) => {
  const { formData, formattedDate, onChange, isAdmin, readOnly } = props;

  const [showDateTimeModal, setShowDateTimeModal] = useState(false);
  const [showMeetingDetailsModal, setShowMeetingDetailsModal] = useState(false);
  const [showVenueModal, setShowVenueModal] = useState(false);

  const isEditable = () => {
    return isAdmin || (!isAdmin && formData?.is_active === false && readOnly === false);
  };

  return (
    <div className={`pt-[36px] px-[80px] flex flex-col gap-9 ${window.innerWidth <= 768 ? 'overflow-x-hidden h-full' : ''}`}>
      <h1 className="heading-24">When and where?</h1>
      <div className="flex flex-col gap-8">
        <div className="flex gap-4 justify-between">
          <LabelField title="Date" 
            text={formattedDate}
          />
          {isEditable() && (<Button 
            type="tertiary-text-underlined" 
            onClick={() => setShowDateTimeModal(true)}
          >
            Edit
          </Button>)}
        </div>

        {formData?.type === 'online' && (
          <>
            <div className="flex gap-4 justify-between">
              <LabelField title="Event link"
                text={formData?.meeting_link} />
              {(!readOnly || isAdmin || (!isAdmin && (differenceInHours(formData?.end_date, new Date()) > 2))) && (<Button type="tertiary-text-underlined" 
                onClick={() => setShowMeetingDetailsModal(true)}>
                Edit
              </Button>)}
            </div>
            <LabelField title="Meeting ID (Optional)" 
              text={formData?.meeting_id} />
            <LabelField title="Password" 
              text={formData?.meeting_password} />
          </>
        )}

        {formData?.type === 'offline' && (
          <div className="flex gap-4 justify-between">
            <LabelField title="Venue" 
              text={formData?.event_address?.name} />
            {isEditable() && (<Button type="tertiary-text-underlined" 
              onClick={() => setShowVenueModal(true)}>
              Edit
            </Button>)}
          </div>
        )}
      </div>

      <DateTimeModal
        setShow = {setShowDateTimeModal}
        show={showDateTimeModal} 
        onClose={() => setShowDateTimeModal(false)} 
        formData={formData}
        onChange={onChange}
      />

      <VenueModal
        show={showVenueModal} 
        onClose={() => setShowVenueModal(false)} 
        isAdmin={isAdmin}
        formData={formData} 
        onChange={onChange}
      />

      <MeetingDetailsModal 
        show={showMeetingDetailsModal} 
        onClose={() => setShowMeetingDetailsModal(false)} 
        formData={formData}
        onChange={onChange}
      />
    </div>
  );
};

export default Locale;
